"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../actions/types");
var _streamHelper = require("../../utils/streamHelper");
var _routeMatch = require("../../utils/routeMatch");
var _SocketEvents = require("../../constants/SocketEvents");
function streamRecordStatus(socket) {
  return function (store) {
    return function (next) {
      return function (action) {
        var targetedActions = [_types.BROADCAST_UPDATE_STREAM_REALTIME, _types.BROADCAST_UPDATE_RECORDING_REALTIME, "".concat(_types.BROADCAST_STOP_STREAM, "_SUCCESS"), "".concat(_types.BROADCAST_STOP_STREAMS, "_SUCCESS"), "".concat(_types.BROADCAST_STOP_RECORDING, "_SUCCESS")];
        (0, _rxjs.from)([action]).pipe((0, _operators.filter)(function ($action) {
          return targetedActions.includes($action.type);
        })).subscribe(function ($action) {
          var _store$getState = store.getState(),
            streamEndpoints = _store$getState.streamEndpoints,
            broadcastRecordings = _store$getState.broadcastRecordings,
            broadcastStreamEndpoints = _store$getState.broadcastStreamEndpoints;
          var liveRecordings = broadcastRecordings === null || broadcastRecordings === void 0 ? void 0 : broadcastRecordings.liveRecordings;
          var endpoints = streamEndpoints || broadcastStreamEndpoints;
          var payload = $action.payload,
            type = $action.type;
          var streaming = (0, _streamHelper.getStreamingStatus)(endpoints);
          var recording = (0, _streamHelper.getRecordingStatus)(liveRecordings);
          var streamStarting = (0, _streamHelper.getStreamStartingStatus)(endpoints);
          switch (type) {
            case _types.BROADCAST_UPDATE_STREAM_REALTIME:
              {
                var currentEndPointStreaming = (0, _streamHelper.isStreaming)(payload);
                streaming = currentEndPointStreaming || streaming;
                streamStarting = (0, _streamHelper.isStreamStarting)(payload);
                break;
              }
            case _types.BROADCAST_UPDATE_RECORDING_REALTIME:
              {
                recording = (0, _streamHelper.isRecording)(payload);
                break;
              }
            case "".concat(_types.BROADCAST_STOP_STREAM, "_SUCCESS"):
            case "".concat(_types.BROADCAST_STOP_STREAMS, "_SUCCESS"):
              {
                var updatedStreams = mergeStreamOrRecording(endpoints, (payload === null || payload === void 0 ? void 0 : payload.endpoints) || []);
                streaming = (0, _streamHelper.getStreamingStatus)(updatedStreams);
                break;
              }
            case "".concat(_types.BROADCAST_STOP_RECORDING, "_SUCCESS"):
              {
                var updatedRecordings = mergeStreamOrRecording(liveRecordings, (payload === null || payload === void 0 ? void 0 : payload.recordings) || []);
                recording = (0, _streamHelper.getRecordingStatus)(updatedRecordings);
                break;
              }
          }
          var streamRecordStatus = {
            isRecording: recording,
            isStreaming: streaming,
            isStreamStarting: streamStarting
          };
          var routeMatch = (0, _routeMatch.getBroadcastRouteMatch)(store.getState);
          if (!routeMatch) return;
          var broadcastId = routeMatch.params.broadcastId;
          socket.emit(_SocketEvents.STREAM_RECORD_STATUS_CHANGE, {
            broadcastId: broadcastId,
            streamRecordStatus: streamRecordStatus
          });
        });
        return next(action);
      };
    };
  };
}

// We use the _id key to merge the streamOrRecording payload with the current streamOrRecording value in state
function mergeStreamOrRecording(arr1, arr2) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_id';
  return arr1.filter(function (elem) {
    return !arr2.find(function (subElem) {
      return subElem[key] === elem[key];
    });
  }).concat(arr2);
}
var _default = exports["default"] = streamRecordStatus;